import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { CartonProvider } from "../../shared/providers/carton.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { CartonModel } from "../../shared/models/carton";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { FrequencyProvider } from "../../shared/providers/frequency.provider";


@Component({
  selector: 'app-cartons-list',
  templateUrl: './cartons-list.component.html',
  styleUrls: ['./cartons-list.component.scss']
})

export class CartonsListComponent implements OnInit {
  addOrEditCarton: string;
  cartons = [];
  title = "modal2";
  formGroup;
  deletePopupUiData;
  frequencyList: any = [];
  formData: any = {};
  voucherCodes: any =[];
  editProfileForm: FormGroup;
  submitted : boolean = false
  brandList : any = []
  page = 1;
  getPaginationCount;
  startDate : any = ""
  countError : boolean = false;
  rewardbifurcationFlag:boolean = false;
  whitelistFlag:boolean = false;
  commMatrixFlag:boolean = false;
  specialOccationFlag: boolean = false;
  targetFlag:boolean = false;
  pointConfigFlag:boolean = false;
  editCarton : any = []

  constructor(
    private fb: FormBuilder,
    public cartonProviders: CartonProvider,
    public adminDataProvider: AdminDataProvider,
    private modalService: NgbModal,
    private router: Router,
    private xlsx: XlsxService,
    private toast: ToastClientService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    public frequencyProvider: FrequencyProvider,
  ) { }
  presentDate:any;
  ngOnInit() {
    this.presentDate = new Date().toISOString().slice(0, 10);
    this.formGroup = this.fb.group({
      cartoonType: new FormControl("",[Validators.required]),
      carton_title : new FormControl("", [Validators.required, Validators.pattern('[A-Za-z0-9 ]*')]),
      brand: new FormControl("", [Validators.required]),
      count: new FormControl("", [Validators.required, Validators.pattern('[0-9]*'),Validators.min(0)]),
      start_date: new FormControl("", [Validators.required]),
      end_date: new FormControl("", [Validators.required]),
    });
    debugger
    this.getCartonList();
    this.getBrand();
  }

  ngDoCheck() {

  }

  getCartonList(){
    this.apiService.getHeaders(this.apiConfig.cartonCampaignList +`?page=${this.page}`).subscribe((res : any)=>{
      console.log(res);
      try{
        this.cartons = res.body.data;
        this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
        console.log("pagination",res)
      }catch{}
    })
  }

  addCarton(id,cartonid,type) {
    console.log(cartonid)
    // 1 is create and 2 is edit
    this.router.navigate(["/hubAdmin/carton-steps/"+id +"/"+cartonid+"/"+type])
    let cartonFlags = {
      whiteListFlag : false,
      pointConfigrationFlag : false,
      targetFlag: false,
      specialOccasionFlag: false,
      rewardBifurcation: false,
      type2Whitelist: false,
      communicationMatrix: false,
    }
    localStorage.setItem('cartonFlgs' , JSON.stringify(cartonFlags))
  }

  editCartonDetail(id,carton_record){
    this.getCartonList()
    console.log("hell0")
    // this.getCampaignDetail(carton_record.id)
    let cartonFlags = {
      rewardBifurcation: true,
      whiteListFlag :carton_record.reward_bifurcation ? true : carton_record.whitelist,
      communicationMatrix: carton_record.whitelist ? true : carton_record.comm_matrix,
      pointConfigrationFlag : carton_record.whitelist ? true : carton_record.point_config,
      targetFlag: carton_record.target_setup ?  true: carton_record.point_config,
      specialOccasionFlag: carton_record.target_setup ? true : carton_record.special_occation,
      type2Whitelist: carton_record.whitelist,
      type1whiteList :carton_record.campaign_create ? true : carton_record.whitelist,

    }
    // localStorage.setItem("whiteListFlag",cartonFlags.whiteListFlag);
    // localStorage.setItem("pointConfigrationFlag","true");
    // localStorage.setItem("targetFlag","true");
    // localStorage.setItem("specialOccasionFlag","true");

    localStorage.setItem('cartonFlgs' , JSON.stringify(cartonFlags))
    console.log(JSON.parse(localStorage.getItem('cartonFlgs')),cartonFlags)
    if(carton_record.carton_feature_id == 1){
      localStorage.setItem("type",carton_record.carton_feature_id);
      this.router.navigate(["/hubAdmin/carton-steps/"+id+"/"+carton_record.id+"/"+carton_record.carton_feature_id])
    }else if(carton_record.carton_feature_id == 2){
      localStorage.setItem("type",carton_record.carton_feature_id);
      carton_record.carton_feature_id == 2 && this.router.navigate(["/hubAdmin/carton-steps/"+id+"/"+carton_record.id+"/"+carton_record.carton_feature_id])
    }
  }
  // getCampaignDetail(cartonid) {
  //   this.apiService.get(this.apiConfig.CartonCampaignDetail + `?carton_campaign_id=${cartonid}`).subscribe((res: any) => {
  //     console.log(res)
  //     this.editCarton = res.data.data;
  //     this.rewardbifurcationFlag = res.data.data.reward_bifurcation;
  //     this.commMatrixFlag = res.data.data.comm_matrix;
  //     this.specialOccationFlag = res.data.data.special_occation;
  //     this.targetFlag = res.data.data.target_setup;
  //     this.pointConfigFlag = res.data.data.point_config;
  //     this.whitelistFlag = res.data.data.whitelist;
  //     console.log(this.editCarton)
  //   })
  // }

  generateQR(){
      if(this.formGroup.invalid){
        this.toast.Error("All fields required")
        return
      }else if(parseInt(this.formGroup.controls.count.value) >= 5000){
            this.countError = true
      }
      else{
        let payload = {
          carton_feature_type:this.formGroup.controls.cartoonType.value,
          carton_title:this.formGroup.controls.carton_title.value,
          qr_count:this.formGroup.controls.count.value,
          carton_brand_id:this.formGroup.controls.brand.value,
          start_date:this.formGroup.controls.start_date.value,
          end_date:this.formGroup.controls.end_date.value
        }
        console.log(payload)
        this.apiService.post(this.apiConfig.generateQRCarton , payload).subscribe((res : any)=>{
          console.log(res);
          this.toast.Success(res.body.data.message)
          this.countError = false
          this.dismissModal();
        },err=>{
          this.countError = false
          console.log(err)
          this.toast.Error(err)
        })
      }
  }

  openQRModel(modal){

    this.modalService.open(modal, {
      centered: true,
      backdrop: "static",
    });
  }
  get f() {
    return this.formGroup.controls;
  }
  dismissModal(){
    this.modalService.dismissAll();
    this.formGroup.reset();
    this.countError = false
    this.startDate = "";
  }
  getBrand(){
    this.apiService.get(this.apiConfig.getCartonBrand).subscribe((res :any)=>{
      console.log(res);
      this.brandList = res.data;
    })
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getCartonList();
  }
  gotoQrdownload(){
    this.router.navigateByUrl("/hubAdmin/qr-download")
  }

}

